export default __webpack_public_path__ + "media/images/quotemark-dbf0c4141f60265f4ef3e54d15b759d1.svg";